(function () {
  const STATUS_READY = 'ready';
  const STATUS_EMPTY = 'empty';
  const STATUS_LOADING = 'loading';

  function normalizeType(value) {
    return String(value || '').trim().toLowerCase();
  }

  function buildSearchUrl(root, query) {
    const url = new URL(root.dataset.searchUrl || '/search', window.location.origin);
    url.searchParams.set('view', 'bazzai-complete-set');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    return url;
  }

  function initCompleteSet(root) {
    if (!root || root.dataset.completeSetStatus !== 'idle') return;

    const designTag = String(root.dataset.designTag || '').trim();
    const currentType = normalizeType(root.dataset.currentProductType);
    const currentProductId = String(root.dataset.currentProductId || '').trim();
    const target = root.querySelector('[data-complete-set-results]');

    if (!designTag || !currentType || !target) {
      root.dataset.completeSetStatus = STATUS_EMPTY;
      root.hidden = true;
      return;
    }

    root.dataset.completeSetStatus = STATUS_LOADING;

    fetch(buildSearchUrl(root, designTag), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html) return [];
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll('.bazzai-complete-set-card'));
      })
      .then((cards) => {
        const matches = cards
          .filter((card) => String(card.dataset.productId || '').trim() !== currentProductId)
          .filter((card) => normalizeType(card.dataset.productType) !== currentType)
          .slice(0, 3);

        target.replaceChildren();

        if (!matches.length) {
          root.dataset.completeSetStatus = STATUS_EMPTY;
          root.hidden = true;
          return;
        }

        matches.forEach((card) => target.appendChild(document.importNode(card, true)));
        root.hidden = false;
        root.dataset.completeSetStatus = STATUS_READY;
      })
      .catch(() => {
        root.dataset.completeSetStatus = STATUS_EMPTY;
        root.hidden = true;
      });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-complete-set]').forEach(initCompleteSet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
